var map = {
	"./404.svg": "a14a",
	"./admin-ico.svg": "444a",
	"./assistant.svg": "d919",
	"./auth-ico.svg": "02e2",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./class-ico.svg": "5855",
	"./clipboard.svg": "bc35",
	"./commodity.svg": "2fa5",
	"./component.svg": "56d6",
	"./content-ico.svg": "4f52",
	"./course-ico.svg": "6256",
	"./customer-ico.svg": "882d",
	"./dashboard.svg": "f782",
	"./device-ico.svg": "7819",
	"./documentation.svg": "90fb",
	"./drag-ico.svg": "b311",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./filter.svg": "c886",
	"./finance-ico.svg": "6122",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./icon-location.svg": "3b6b",
	"./icon-start.svg": "a5d1",
	"./icon-stop.svg": "844f",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./line-icon.svg": "25f1",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./marketing-ico.svg": "a833",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nandu.svg": "5f93",
	"./nested.svg": "dcf8",
	"./nps.svg": "f65c",
	"./operate-ico.svg": "e0e8",
	"./order-ico.svg": "9e7a",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./pic-icon.svg": "2a10",
	"./push.svg": "dc9d",
	"./qq.svg": "1430",
	"./quality.svg": "f22a",
	"./recharge-ico.svg": "c512",
	"./school-ico.svg": "471a",
	"./search.svg": "8e8d",
	"./sgmall.svg": "9c05",
	"./shangpin-ico.svg": "f9ab",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./star.svg": "708a",
	"./statistics.svg": "a1cf",
	"./stu-ico.svg": "41b5",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./task-manage.svg": "674c",
	"./template-ico.svg": "ceed",
	"./theme.svg": "e534",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./video-ico.svg": "06bc",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";